export default __webpack_public_path__ + "static/media/green_thumb.fd1a1794.svg";